import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { submit } from 'redux-form'
import * as $ from 'jquery';
import Alert from '../../../../../../../itrust_common/components/Alert';
import { getInsuranceFromRPAServices } from '../../../../other/AddOnsHelperFunctions';
import { visionInsuranceServicesLoad } from '../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction';
import { visionInsuranceClaimFormSubmit, visionInsuranceClaimFormUpdate } from '../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import { orderLoad } from '../../../../../../../redux/actions/order/orderActions';
import useInsuranceMappedFailed from '../../useInsuranceMappedFailed';
import { DIRECT_SAVE_CLAIM_OPTIONS, isDirectSaveClaimOrg } from '../directSaveClaimOrgHelper';
import { withOrdersInsuranceId } from '../../../../../../../components/authorised/order/claimFormDropdownUtils';

const CLAIM_FORM_BY_SERVICE = {
  eyemed: 'EyeMedClaimForm',
  spectera: 'SpecteraClaimForm',
  eyefinity: 'EyefinityClaimForm',
  versant: 'VersantClaimForm',
}

function RpaClaimSubmitButton(props) {
  const { rpaSubmitting, order, visionInsuranceConfig, services, visionInsuranceClaimForm, organisation, hasSelectedService, formValues, editing, selectedOrderInsurance } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const isDirectSaveOrg = isDirectSaveClaimOrg(organisation?.subdomain, order?.store_id)
  const isSendDisabled = isDirectSaveOrg && !hasSelectedService
  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === (selectedOrderInsurance?.id || editing?.orders_insurance_id),
  ) || selectedOrderInsurance
  const patientInsurance = orderInsurance?.patient_insurance_attributes
  const visionInsuranceService = orderInsurance?.vision_insurance_service

  const { rpaVerificationFailed, insuranceVerificationFailed } = useInsuranceMappedFailed(patientInsurance?.insurance_name)

  useEffect(() => {
    let storeID = localStorage.getItem('StoreID')
    if (storeID == null) {
      dispatch(visionInsuranceServicesLoad({ store_id: order.store_id, category: "vision_insurance" }))
    }
  }, [])

  const handleRpaClaimSubmit = async () => {
    if (isSendDisabled) return

    if (isDirectSaveOrg) {
      await saveThenSubmitClaim()
      return
    }

    if (rpaVerificationFailed) {
      insuranceVerificationFailed()
    }
    else {
      if (visionInsuranceConfig?.status !== 'inactive') {
        if (visionInsuranceClaimForm.ready_to_submit || visionInsuranceService?.service === '2020source') {
          submitClaim()
        }
        else {
          Alert.warning("Your claim form isn't ready to submit yet. Please complete the form filling process.")
        }
      }
      else {
        history.push('/add-ons/vision-insurance/dashboard')
        $('#orderForm-modal').modal('hide');
      }
    }
  }

  const saveThenSubmitClaim = async () => {
    const claimData = formValues || visionInsuranceClaimForm
    if (!claimData?.eligibility?.data?.find(item => item.active)) {
      Alert.warning('Please select a service to proceed.')
      return
    }

    const location = document.getElementById('direct-save-claim-location')?.value
      || claimData.location
      || visionInsuranceClaimForm?.location
      || DIRECT_SAVE_CLAIM_OPTIONS[0].value

    await dispatch(visionInsuranceClaimFormUpdate(
      { ...claimData, id: claimData.id || visionInsuranceClaimForm?.id, location },
      withOrdersInsuranceId({ claim_sections: ['eligibility'] }, orderInsurance?.id || editing?.orders_insurance_id),
    ))
    submitClaim()
  }

  const submitClaim = () => {
    const insurance = getInsuranceFromRPAServices(services, patientInsurance?.insurance_name)
    dispatch(submit("1500ClamForm"))
    setTimeout(() => {
      let invalidInputs = (document.getElementsByClassName("is-invalid")?.length || document.getElementsByClassName("invalid-feedback")?.length)
      if (invalidInputs) {
        Alert.warning("Please fill the required information.")
      } else {
        dispatch(visionInsuranceClaimFormSubmit({
          add_ons_id: insurance.id,
          orders_order_id: order.id,
          orders_insurance_id: orderInsurance?.id,
          patient_id: order.patient_id,
          insurance_type: patientInsurance?.insurance_type,
          store_id: order.store_id,
          insurance_payer: patientInsurance?.insurance_name,
          service: insurance.config.service,
          other_details: { resource: "submit_claim" },
        }))
          .then(() => dispatch(orderLoad(order.id, { include: '*' })))
      }
    }, 500)
  }

  return (
    <>
      {rpaSubmitting ?
        <button className="btn btn-outline-primary mr-lg-7 mr-md-5 mx-md-4 my-md-2 mx-lg-0 my-lg-0">Sending...</button> :
        <button
          className={`btn btn-outline-primary ${rpaVerificationFailed ? 'btn-outline-danger' : 'btn-outline-primary'} mr-lg-7 mr-md-5 mx-md-4 my-md-2 mx-lg-0 my-lg-0`}
          onClick={handleRpaClaimSubmit}
          disabled={isSendDisabled}
        >
          Send to {patientInsurance?.insurance_name}
        </button>
      }
    </>
  )
}
const mapStateToProps = (state, ownProps) => {
  const { organisation: { organisation }, visionInsurance: { services }, visionInsuranceClaimForm: { visionInsuranceClaimForm, submitting, editing } } = state
  const orderInsurance = ownProps.order?.orders_insurances_attributes?.find(
    (item) => item.id === (ownProps.selectedOrderInsurance?.id || editing?.orders_insurance_id),
  )
  const formName = CLAIM_FORM_BY_SERVICE[orderInsurance?.vision_insurance_service?.service]
  const formValues = state.form?.[formName]?.values
  const eligibilityData = formValues?.eligibility?.data || visionInsuranceClaimForm?.eligibility?.data

  return {
    rpaSubmitting: submitting,
    organisation,
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    services,
    visionInsuranceClaimForm,
    formValues,
    editing,
    hasSelectedService: !!eligibilityData?.find(item => item.active),
  }
}

export default connect(mapStateToProps)(RpaClaimSubmitButton)
